/** 各フェーズ定義 */
export const PHASE = {
  WAIT: 'wait', // 待機
  FACTORY_MODE_DISPLAY: 'factoryModeDisplay', // 工場モード表示
  DEALER_MODE_DISPLAY: 'dealerModeDisplay', // 市場モード表示
  STOP: 'stop', // 停止
  ERROR: 'error', // エラー
  FAILED: 'failed', // 共通エラー
};

/** データ読出し結果 */
export const READ_RESULT = {
  DEALER: 'dealer', // 市場モード表示
  FACTORY: 'factory', // 工場モード表示
  OTHER: 'other' // 上記以外
};

/** 工場モード表示・市場モード表示で選択できるモード名 */
export const MODE_NAME = {
  IGON_MODE: 'ig_on', // 常時電源ONモード
  IGOFF_MODE: 'ig_off', // 常時電源OFFモード
  RESTRICTION_MODE_END: 'end', // 電源遷移制限モード終了
};

/** Exit API 実行後の遷移 */
export const EXIT_FLOW = {
  STOP: 'stop', // 停止画面へ遷移
  ERROR: 'error', // エラー画面へ遷移
  CLOSE: 'close' // 機能終了
};

